import type {
  HubAlgorithmDefinition,
  HubParameterDefinitionField,
  HubParameterDependency,
  HubParameterGroupDefinition,
} from '@robovision/hub'
import {
  JobBaseDependency,
  type JobBaseDependencyParams,
} from './JobBaseDependency'


export interface JobParameterDependencyParams extends JobBaseDependencyParams {
  fields: HubParameterDefinitionField[]
  groups: HubParameterGroupDefinition[]
  name: string
}

export class JobParameterDependency extends JobBaseDependency {
  public fields: HubParameterDefinitionField[]
  public groups: HubParameterGroupDefinition[]
  public override name: string = 'JobParameterDependency default name'

  protected constructor (params: JobParameterDependencyParams) {
    super(params)
    this.fields = params.fields
    this.groups = params.groups
    this.name = params.name
  }

  public static fromDefinition (
    parameterDependency: HubParameterDependency,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const def = algorithmDefinition.parameterDefinitions?.find(
      (def) => def.id === parameterDependency.parameterDefinition,
    )

    if (!def) {
      throw new Error(
        `Invalid schema. Parameter definition ${parameterDependency.parameterDefinition} not found`,
      )
    }

    return new JobParameterDependency({
      definitionId: def.id,
      dependencyId: parameterDependency.id,
      description: parameterDependency.description,
      fields: def.schema?.fields ?? [],
      groups: def.schema?.groups ?? [],
      name: parameterDependency.name ?? def.name,
    })
  }
}
